export const reportingSelector = (state) => state.controls.reporting;
export default reportingSelector;
